import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';

/**
 * TODO se basé sur : https://github.com/rajaramtt/ng7-dynamic-breadcrumb/blob/master/projects/ng-dynamic-breadcrumb/src/lib/ng-dynamic-breadcrumb.component.ts
 https://codecraft.tv/courses/angular/routing/route-configuration/
 */
@Component({
    selector: 'dmp-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {

  private items: MenuItem[];



  constructor(protected activatedRoute: ActivatedRoute,
    ) { }

  ngOnInit() {
    this.activatedRoute.data.subscribe(data => {
      if (data && data.breadcrumb){
        this.items = [];
        const breadcrumbs = data.breadcrumbs;
        breadcrumbs.forEach(breadcrumb => {
          this.items.push();
        });
      }
    });


    this.items = [
      {label:'Categories'},
      {label:'Sports'},
      {label:'Football'},
      {label:'Countries'},
      {label:'Spain'},
      {label:'F.C. Barcelona'},
      {label:'Squad'},
      {label:'Lionel Messi', url: 'https://en.wikipedia.org/wiki/Lionel_Messi'}
  ];
  }

}
